var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 321,
    viewBox: "0 0 378 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.451 81.6241L101.232 23L70 38.0451M220.451 81.6241L189.406 96.6692M220.451 81.6241V112.233L189.406 127.797M70 38.0451L189.406 96.6692M70 38.0451V69.1729L189.406 127.797M189.406 96.6692V127.797M101.232 84.218L70 99.2632M70 99.2632L158.195 142.821M70 99.2632V130.391L189.406 189.015L220.451 173.451V159.444M101.5 146L70 161.519M70 161.519L158.195 205.077M70 161.519V192.647L189.406 251.271M220.451 221.699V235.707L189.406 251.271M189.406 251.271V236.744M189.406 236.744L158.195 221.18V190.571M189.406 236.744L308.647 178.12V146.992M189.406 236.744V205.617M158.195 128.316L189.406 143.361M158.195 128.316V158.925L189.406 174.489M158.195 128.316L174.019 120.534M189.406 143.361L308.647 84.7368M189.406 143.361V174.489M308.647 84.7368L277.104 69.6917L220.451 97.7068M308.647 84.7368V115.865L189.406 174.489M276.5 131.669L308.647 146.992M308.647 146.992L189.406 205.617M158.195 190.571L175.337 182.146M158.195 190.571L189.406 205.617M277.104 193.684L308.647 209.248M308.647 209.248L189.406 267.872M308.647 209.248V240.376L189.406 299M158.195 252.827L189.406 267.872M158.195 252.827V283.436L189.406 299M158.195 252.827L175 244.198M189.406 267.872V299",
    stroke: "#DD3837",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.f9430e66d51a59c29fa0b454780590fd.svg";
export { ForwardRef as ReactComponent };